import styled from 'styled-components';

export const TableWrapper = styled.div``;

export const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  ${({ theme }) => theme.breakpoints.md.query} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.breakpoints.sm.query} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
